/** Piezas visuales compartidas por las pantallas del cierre. */

import type { Homologation } from "../../api/types";
import { useClosing } from "./closingContext";

/*
 * Aquí vivía `HomologationBadge`, el distintivo «Pendiente del contador» /
 * «Aprobado» de cada pestaña.
 *
 * Se retira por lo mismo que se retiró la marca de borrador del PDF: estaba
 * encendido en toda pantalla —el contador no había aprobado todavía, y no
 * aprueba hasta que firma— así que dejó de distinguir nada. El estado se sigue
 * calculando y sigue viajando en `/api/config` y en `/api/closing`, para las
 * pantallas de administración; lo que se retira es imprimirlo sobre cada
 * estado financiero como si fuera parte del estado.
 */

/**
 * Encabezado común de cada estado: razón social, título y fecha de corte.
 *
 * SIN distintivo de homologación: ya no lo lleva ninguna pantalla. El parámetro
 * se mantiene para no obligar a las once pantallas a dejar de pasarlo y para que
 * siga documentando qué pieza es cada una.
 */
export function StatementHead({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
  homologation?: Homologation;
}) {
  const { package: pkg } = useClosing();
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        <p>
          {pkg.cover.company} · {subtitle ?? `al ${pkg.period_to}`} ·{" "}
          {pkg.cover.currency_note}
        </p>
      </div>
    </div>
  );
}
